import { step as IdSelectTip } from "./id-select";
import { step as AddLensSubscriptionTip } from "./add-lens-subscription";
import { step as ManageSeatsTip } from "./manage-seats";

const tours = [
  {
    id: "user-select-tour",
    steps: [IdSelectTip],
  },
  {
    id: "business-id-tour",
    steps: [AddLensSubscriptionTip, ManageSeatsTip],
  },
];

export default tours;
